/**
 * EN content for the "Saint-Tropez" private excursion.
 *
 * Role: English translation of slugs/saint-tropez.ts, typed `ExcursionPage`
 * for the shared ExcursionSlugView.
 * Dependencies: slug-excursions (type), image. Slug mirrors FR (place name).
 */
import type { ExcursionPage } from "../slug-excursions";
import sttrop from "@/assets/images/excursions/destinations/st-trop.webp";

const page: ExcursionPage = {
  slug: "saint-tropez",
  hero: {
    title: "Saint-Tropez Excursion",
    subtitle:
      "A legendary harbour, beaches and Provençal lanes, in complete serenity.",
    ctaPrimaryHref: "/en/reservation",
    ctaPrimaryLabel: "Book now",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "Get a quote",
    image: sttrop,
  },
  highlights: {
    title: "Highlights",
    items: [
      { text: "Saint-Tropez harbour, yachts and legendary cafés" },
      { text: "The citadel and typical Provençal lanes" },
      { text: "Pampelonne beaches nearby" },
      { text: "Coastal views along the Var road" },
    ],
  },
  itinerary: {
    title: "Sample itinerary",
    steps: [
      {
        title: "Drive Cannes → Saint-Tropez",
        description: "Coastal Var landscapes.",
      },
      {
        title: "Historic centre",
        description: "Harbour, citadel (optional), boutiques.",
      },
      {
        title: "Free time",
        description: "Coffee break, beach depending on the season.",
      },
      {
        title: "Pampelonne (optional)",
        description: "Swimming / private beach depending on the season.",
      },
    ],
  },
  practical: {
    title: "Practical information",
    items: [
      { label: "Duration", value: "6 to 8 hours" },
      { label: "Tip", value: "Avoid peak hours in summer" },
      { label: "Departure", value: "Cannes" },
      { label: "Option", value: "Pampelonne beach / Citadel" },
    ],
  },
  seo: {
    title: "Saint-Tropez Excursion from Cannes | Private Chauffeur",
    description:
      "Private day trip from Cannes to Saint-Tropez with a chauffeur: legendary harbour, citadel, Provençal lanes and the Pampelonne beaches.",
    canonical: "/en/excursions/saint-tropez",
  },
};

export default page;
